import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../../StaticText/connect'
import { getBoundActions } from '../../../actions/index'
import Button, { TYPES } from '../../Button/index'
import { PLAN_SELECT_PRECURSOR_GA4_EVENT } from '../../../services/event-tracking/index'

/**
 * Component to allow user to select a different plan
 * @param {Map} props.staticText - Static text translations
 * @param {Map} props.selectedPlan - Selected plan data
 * @param {Function} props.setPlansSelection - Function to set plan selection
 * @param {Function} props.setRenderWinback - Function to set winback render state
 */
function CartSinglePageSelectPlan (props) {
  const {
    staticText,
    selectedPlan,
    setRenderWinback,
    setPlansSelection,
    setEventDefault,
    setCheckoutSinglePageStep,
    sendOptimizelyFeatureEvent,
  } = props

  const handleSelectPlan = () => {
    // GA4 + optimizely event for Plan Selected
    setEventDefault(PLAN_SELECT_PRECURSOR_GA4_EVENT)
    sendOptimizelyFeatureEvent({ eventName: 'plan_selected' })

    // Set Checkout step
    setCheckoutSinglePageStep(3, 5)

    // Winback flow step update
    setPlansSelection(selectedPlan)
    setRenderWinback(false)
  }

  return (
    <div className="winback__select-plan">
      <Button
        type={TYPES.SECONDARY}
        onClick={handleSelectPlan}
        className="winback__button winback__select-plan-button"
      >
        {staticText.getIn(['data', 'viewOtherPlans'])}
      </Button>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'CartSinglePage' }),
  connectRedux(
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPlansSelection: actions.plans.setPlansSelection,
        setEventDefault: actions.eventTracking.setEventDefault,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
        setCheckoutSinglePageStep: actions.checkout.setCheckoutSinglePageStep,
      }
    },
  ),
)(CartSinglePageSelectPlan)
